<template>
<panel>
    <p slot="header">
        Eksport adresów e-mail do pliku .csv
    </p>
    <p slot="actions">
        <ui-button type="flat" color="primary" icon="navigate_before" @click="$router.push({name: 'admin.emails.dashboard'})">Wróć</ui-button>
    </p>


    <form @submit.prevent="submit"  autocomplete="off">
        <ui-alert type="error" v-for="e, index in errors" :key="index" :dismissible="false">{{ e }}</ui-alert>

        <i-select name="separator" label="Separator" :keys="keysForSelect" :default="default_separator" v-model="separator" :options="separators" placeholder="Wybierz separator" required></i-select>

        <i-select-multiple name="groups" label="Grupa" :keys="keysForSelect" v-model="email_groups" :options="groups" search-placeholder="Szukaj" :show-search="true" placeholder="Wybierz grupy które chcesz eksportować"></i-select-multiple>

        <div class="form-actions">
            <ui-button color="primary" icon="file_download">Eksportuj adresy</ui-button>
        </div>
    </form>

</panel>

</template>
<script>
import Notify from './../../mixins/Notify'
import Loading from './../../mixins/Loading'
import FormErrors from './../../mixins/FormErrors'

import Utils from './../../services/Utils'
import EmailGroups from './../../services/EmailGroups'
import Emails from './../../services/Emails'

export default {
  mixins: [Notify, Loading, FormErrors],
  data () {
    return {
      separator: ';',
      email_groups: [],
      default_separator: '\t',
      separators: Emails.separators(),
      groups: [],
      keysForSelect: Utils.keysForSelect(),
      errorMessages: Utils.errorMessages(['required', 'min', 'numeric', 'email'])
    }
  },
  mounted () {
    this.getEmailGroups()
  },
  methods: {
    getEmailGroups () {
      this.setLoading(true)
      EmailGroups.names().then(res => {
        this.groups = res.data.items
        this.setLoading(false)
      })
    },
    error (err) {
      this.errors = this.getResponseErrors(err)
      this.notify('Wystąpiły błędy')
    },
    success (res) {
      window.location.href = res.data.url
      this.notify('Plik został wysłany ')
    },
    submit () {
      const separator = this.separator
      const groups = this.email_groups
      Emails.getExportUrl(separator, groups.join(',')).then(this.success, this.error)
    }
  }
}

</script>


// WEBPACK FOOTER //
// ExportEmails.vue?402be490